import Vue from 'vue'
import Router from 'vue-router'

import routes from './routes'
import router from './router'

Vue.use(Router)

const { BASE_URL } = process.env

export default new Router({
  mode: 'history',
  base: BASE_URL,
  routes: [
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Ad Manager',
      },
      name: 'admanager',
      path: '/admanager/:reportName?/:reportId?/:subId?',
      props: router.props,
    },

    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Admin',
      },
      name: 'admin',
      path: '/admin/:reportName?/:reportId?',
      props: router.props,
    },
    {
      path: '/admin/engagements/:reportId?',
      redirect: (to) => `/admin/engagement${to.params.reportId ? `/${to.params.reportId}` : ''}`,
    },

    {
      alias: ['/account'],
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Settings',
      },
      name: 'settings',
      path: '/settings/:reportName?/:reportId?',
      props: router.props,
    },

    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Reports',
      },
      name: 'reports',
      path: '/reports/:reportName?/:reportId?/:subId?',
      props: router.props,
    },
    {
      // Redirecting, so no component is needed.
      // component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Delivery',
      },
      name: 'delivery',
      path: '/delivery/:reportName?/:reportId?/:subId?',
      props: router.props,
      redirect: (to) => {
        const { reportId, reportName, subId } = to.params
        const reportPaths = ['/reports']

        if (reportName) {
          reportPaths.push(reportName)

          if (reportId) {
            reportPaths.push(reportId)

            if (subId) {
              reportPaths.push(subId)
            }
          }
        }

        return {
          path: reportPaths.join('/'),
        }
      },
    },
    {
      // Redirecting, so no component is needed.
      // component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Programmatic',
      },
      name: 'programmatic',
      path: '/programmatic/:reportName?/:reportPath?/:reportId?/:subId?',
      props: router.props,
      redirect: (to) => {
        const { reportId, reportName, subId } = to.params
        const reportPaths = ['/reports']

        if (reportName) {
          const reportNameMap = {
            adx: 'adx-health',
            network: 'network-health',
            partner: 'adx-and-ob',
          }

          const newReportName = reportNameMap[reportName] || reportName

          reportPaths.push(newReportName)

          if (reportId) {
            reportPaths.push(reportId)

            if (subId) {
              reportPaths.push(subId)
            }
          }
        }

        return {
          path: reportPaths.join('/'),
        }
      },
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Docs',
      },
      name: 'docs',
      path: '/docs/:reportName?/:reportId?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Internal',
      },
      name: 'internal',
      path: '/internal/:reportName?/:reportId?',
      props: router.props,
    },

    // Shortcut redirects for internal routes (without /internal/ prefix)
    {
      path: '/organizations/:reportId?',
      redirect: (to) => `/internal/organizations${to.params.reportId ? `/${to.params.reportId}` : ''}`,
    },
    {
      path: '/people/:reportId?',
      redirect: (to) => `/internal/people${to.params.reportId ? `/${to.params.reportId}` : ''}`,
    },
    {
      path: '/projects/:reportId?',
      redirect: (to) => `/internal/projects${to.params.reportId ? `/${to.params.reportId}` : ''}`,
    },

    // Legacy singular form redirects
    {
      path: '/organization/:reportId?',
      redirect: (to) => `/internal/organizations${to.params.reportId ? `/${to.params.reportId}` : ''}`,
    },
    {
      path: '/person/:reportId?',
      redirect: (to) => `/internal/people${to.params.reportId ? `/${to.params.reportId}` : ''}`,
    },
    {
      path: '/project/:reportId?',
      redirect: (to) => `/internal/projects${to.params.reportId ? `/${to.params.reportId}` : ''}`,
    },

    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Custom Reports',
      },
      name: 'custom-reports',
      path: '/custom-reports/:reportName?/:reportId?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Dev',
      },
      name: 'dev',
      path: '/dev/:reportName?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Sign In',
      },
      name: 'sign-in',
      path: '/sign-in',
      props: router.props,
    },
    {
      // requiresAuth: false so autoAuth's early exit (actions.js) skips
      // silent-sign-in attempts here - this route must render for signed-out
      // visitors (including Google's OAuth consent screen review crawler).
      // See Layout.vue's isPrivacyPolicyRoute for the actual render bypass.
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: false,
        title: 'Privacy Policy',
      },
      name: 'privacy-policy',
      path: '/privacy-policy',
      props: router.props,
    },
    {
      // Same reasoning as privacy-policy. The page itself carries a
      // prominent "DRAFT - Pending Legal Review" banner - being publicly
      // reachable doesn't mean it's approved or binding.
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: false,
        title: 'Terms of Service',
      },
      name: 'terms-of-service',
      path: '/terms-of-service',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Reset Password',
      },
      name: 'reset-password',
      path: '/reset-password',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Sign Out',
      },
      name: 'sign-out',
      path: '/sign-out',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Sign Up',
      },
      name: 'sign-up',
      path: '/sign-up',
      props: router.props,
      alias: '/register',
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Forgot Password',
      },
      name: 'forgot-password',
      path: '/forgot-password',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Index',
      },
      name: 'index',
      path: '/index.html',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Dashboard',
      },
      name: 'dashboard',
      path: '/',
      props: router.props,
    },

    // {
    //   component: routes.REDIRECT_PAGE.component,
    //   meta: {
    //     requiresAuth: false,
    //     title: 'Redirect Example',
    //   },
    //   path: '/redirect-example',
    //   alias: '/redirect',
    //   redirect() {
    //     window.location.replace('https://google.com')
    //   },
    // },
  ],
})
